// extracted by mini-css-extract-plugin
export default {"changeLenguage":"lenguage_changeLenguage__CDvh7"};